import { CircularProgress, FormControlLabel } from "@material-ui/core";
import { cx, css } from "emotion";
import React from "react";
import { useQuery } from "react-query";
import SwitchButton from "../../../components/Switch";
import { handleError } from "../../../components/Utils/Utils";
import TenantService from "../../../Services/TenantService/TenantService";
import CreateIcon from "@material-ui/icons/Create";
import OperationalTimeForm from "./OperationalTimeForm";
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";

const OperationalTime = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const { isMobile } = props;
  const [loading, setLoading] = React.useState(true);
  const [openModal, setOpenModal] = React.useState(false);
  const [tenant, setTenant] = React.useState("");
  const [operationalDays, setOperationalDays] = React.useState([]);

  const createFormatTime = (date) => {
    return moment
      .tz(new Date(date), tenant?.property?.timezone || "UTC")
      .format("HH:mm z");
  };

  const getTenantOperationalHours = useQuery(
    ["getTenantOperationalHours", user?.tenant?.id || 0],
    () => {
      return TenantService.getListOperationalHours()
        .then((res) => res.data)
        .catch((error) => {
          handleError(error);
        });
    },
    {
      cacheTime: 0,
      enabled: false,
      onSuccess: (data) => {
        const remap = data?.map((days) => ({
          ...days,
          slots: days?.slots?.map((slot) => ({
            ...slot,
            key_slot: uuidv4(),
            open_time: slot?.open_time,
            close_time: slot?.close_time,
            last_order: slot?.last_order,
          })),
        }));
        setOperationalDays(remap);
      },
    }
  );

  const getDetailTenant = useQuery(
    ["getDetailTenant", user?.tenant?.id || 0],
    () => {
      return TenantService.getByID(user?.tenant?.id)
        .then((res) => res.data)
        .catch((error) => {
          handleError(error);
        });
    },
    {
      cacheTime: 0,
      onSuccess: (data) => {
        setTenant(data);
      },
    }
  );

  const handleToggleModal = () => {
    setOpenModal(!openModal);
    if (openModal) {
      getTenantOperationalHours.refetch();
    }
  };

  const handleChangeOpenSt = (event) => {
    TenantService.patchData(tenant?.id, [
      {
        op: "replace",
        path: "/open_st",
        value: event?.target?.checked,
      },
    ])
      .then(() => {
        getDetailTenant.refetch();
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleChangeOpenFullday = (event) => {
    TenantService.patchData(tenant?.id, [
      {
        op: "replace",
        path: "/open_fullday",
        value: event?.target?.checked,
      },
    ])
      .then(() => {
        getDetailTenant.refetch();
      })
      .catch((error) => {
        handleError(error);
      });
  };

  React.useEffect(() => {
    if (tenant !== "" && !tenant?.open_fullday) {
      getTenantOperationalHours.refetch();
    }
  }, [tenant]);

  return (
    <div
      className={cx(
        css`
          ${isMobile ? "width: 100%;" : "width: 400px"}
        `,
        "px-3 py-2"
      )}
    >
      <h2 className="font-20 font-bold">Jam Operasional</h2>

      {!getDetailTenant?.isLoading && (
        <div className="w-100 mt-4">
          <div className="form-group d-flex justify-content-between align-items-center">
            <label className="font-bold font-12">Buka/Tutup toko manual</label>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <FormControlLabel
                control={
                  <SwitchButton
                    checked={tenant?.open_st}
                    onChange={(event) => {
                      handleChangeOpenSt(event);
                    }}
                    name="checked"
                  />
                }
              />
            </div>
          </div>
          {tenant?.open_st && (
            <div className="form-group d-flex justify-content-between align-items-center">
              <label className="font-bold font-12">Buka 24 jam</label>
              <FormControlLabel
                control={
                  <SwitchButton
                    checked={tenant?.open_fullday}
                    onChange={(event) => {
                      handleChangeOpenFullday(event);
                    }}
                    name="checked"
                  />
                }
              />
            </div>
          )}
          {operationalDays?.length > 0 &&
            !getTenantOperationalHours?.isLoading &&
            !tenant?.open_fullday &&
            tenant?.open_st && (
              <div className="form-group">
                <label className="font-bold font-12">
                  Atur jam operasional harian
                </label>
                <div className="d-flex justify-content-start align-items-start">
                  <ul className="list-group list-group-flush flex-grow-1">
                    {operationalDays?.map((day, index) => (
                      <React.Fragment key={index}>
                        <li
                          className="list-group-item border-0 pl-0"
                          key={index + "0"}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            {!day?.open_st && (
                              <span className="font-12 text-capitalize text-danger">
                                {day?.day}
                              </span>
                            )}
                            {day?.open_st && (
                              <span className="font-12 text-capitalize">
                                {day?.day}
                              </span>
                            )}
                            {day?.open_st && day?.slots?.length > 0 && (
                              <div className="d-flex justify-content-end align-items-center">
                                <span className="font-12 mr-3">
                                  {`${createFormatTime(
                                    day?.slots[0]?.open_time
                                  )} - ${createFormatTime(
                                    day?.slots[0]?.close_time
                                  )}`}
                                </span>
                                <span className="font-12">
                                  {`${createFormatTime(
                                    day?.slots[0]?.last_order
                                  )}`}
                                </span>
                              </div>
                            )}
                            {!day?.open_st && (
                              <div className="d-flex justify-content-start align-items-center">
                                <span className="font-12 text-capitalize text-danger">
                                  Tutup
                                </span>
                              </div>
                            )}
                          </div>
                        </li>
                        {day?.open_st &&
                          day?.slots?.length > 1 &&
                          day?.slots?.map(
                            (slot, idxSlot) =>
                              idxSlot > 0 && (
                                <li
                                  className="list-group-item border-0 pl-0"
                                  key={slot?.key_slot}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span className="font-12 text-capitalize"></span>
                                    <div className="d-flex justify-content-end align-items-center">
                                      <span className="font-12 mr-3">
                                        {`${createFormatTime(
                                          slot?.open_time
                                        )} - ${createFormatTime(
                                          slot?.close_time
                                        )}`}
                                      </span>
                                      <span className="font-12">
                                        {`${createFormatTime(
                                          slot?.last_order
                                        )}`}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              )
                          )}
                      </React.Fragment>
                    ))}
                  </ul>
                  <button
                    type="button"
                    className="btn btn-white-transparent"
                    onClick={() => handleToggleModal()}
                  >
                    <CreateIcon />
                  </button>
                </div>
              </div>
            )}
          {getTenantOperationalHours?.isLoading && (
            <div
              className={cx(
                css`
                  width: 100%;
                  height: 20vw;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                `,
                "mt-3"
              )}
            >
              <CircularProgress />
            </div>
          )}
        </div>
      )}
      {getDetailTenant?.isLoading && (
        <div
          className={cx(
            css`
              width: 100%;
              height: 20vw;
              display: flex;
              justify-content: center;
              align-items: center;
            `,
            "mt-3"
          )}
        >
          <CircularProgress />
        </div>
      )}
      {operationalDays?.length > 0 && (
        <OperationalTimeForm
          openModal={openModal}
          operationalDays={operationalDays}
          tenant={tenant}
          handleToggle={handleToggleModal}
        />
      )}
    </div>
  );
};

export default OperationalTime;
